import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'app-summary-card-icon',
})
export class SummaryCardIconDirective {
  @HostBinding('class') elClass = 'summary-card-icon';
}
